import React from 'react';
import { useGoodsReviewsPhotoFeeds } from '../../queries/useGoodsReviewsPhotoFeeds';
import {
  Colors,
  Flex,
  IconTag,
  RemoteImage,
  Typography,
} from '@banhala/ui-kit';
import { usePhotoReviewSize } from '../../hooks/usePhotoReviewSize';
import { localizeNumber, useNavigator } from 'shared/src/utils';
import { useGoodsSno } from '../../../../../../hooks/useGoodsSno';

const ReviewItemMedia: React.FC<{
  videoUrl: string | null;
  imageUrl: string;
  hasCodiGoods: boolean;
  isLastItem: boolean;
  totalCount: number;
  onPressItem: () => void;
}> = props => {
  const photoReviewSize = usePhotoReviewSize();

  return (
    <Flex
      width={photoReviewSize}
      height={photoReviewSize}
      borderRadius={'small'}
      overflow={'hidden'}
      onPress={props.onPressItem}
    >
      <RemoteImage
        uri={props.imageUrl}
        width={photoReviewSize}
        height={photoReviewSize}
      />
      {props.hasCodiGoods && (
        <Flex.Center
          position={'absolute'}
          right={6}
          bottom={6}
          width={28}
          height={28}
          borderRadius={14}
          backgroundColor={'black'}
          backgroundColorOpacity={0.4}
        >
          <IconTag size={20} fill={Colors.content_always_white} />
        </Flex.Center>
      )}
      {props.isLastItem && (
        <Flex.Center
          position={'absolute'}
          left={0}
          right={0}
          top={0}
          bottom={0}
          backgroundColor={'black'}
          backgroundColorOpacity={0.4}
        >
          <Typography type={'h5'} color={'content_always_white'}>
            +{localizeNumber(props.totalCount - 4)}
          </Typography>
        </Flex.Center>
      )}
      {/*{props.hasCodiGoods && <IconCodi />}*/}
    </Flex>
  );
};

export const ReviewSummaryPhotoReviewList: React.FC = () => {
  const goodsSno = useGoodsSno();
  const { data: photoFeeds } = useGoodsReviewsPhotoFeeds();
  const { navigator } = useNavigator();

  const totalCount = photoFeeds?.total_count ?? 0;

  if (totalCount === 0) return null;

  return (
    <Flex.Row padding={{ horizontal: 16, top: 12, bottom: 0 }} gap={4}>
      {photoFeeds.reviews.slice(0, 4).map((review, index) => {
        const isLastPhoto = index === 3 && totalCount > 4;
        return (
          <Flex
            key={review.sno.toString()}
            testID={
              isLastPhoto
                ? '리뷰사진모아보기'
                : `리뷰사진리스트&LIST_INDEX=${index}`
            }
          >
            <ReviewItemMedia
              imageUrl={review.images_webp[0]}
              videoUrl={review.video_url}
              hasCodiGoods={review.has_codi_goods}
              isLastItem={isLastPhoto}
              totalCount={totalCount}
              onPressItem={() => {
                if (isLastPhoto) {
                  navigator.moveToPhotoReviewList({
                    goodsSno,
                  });
                  return;
                }
                navigator.moveToPhotoReviewList({
                  goodsSno,
                  reviewSno: review.sno,
                });
              }}
            />
          </Flex>
        );
      })}
    </Flex.Row>
  );
};
